import { createContext } from 'react';
export const CardsReward_context = createContext(null);
